import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { KanbanViewCardI } from '../../models/kanban-view/kanban-production-viewI';
import { MatCheckbox } from '@angular/material/checkbox';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-production-kanban-view-card',
  templateUrl: './production-kanban-view-card.component.html',
  styleUrls: ['./production-kanban-view-card.component.scss']
})
export class ProductionKanbanViewCardComponent implements OnInit {

  public defaultImg = '../../placeholder-image.png';
  isOverdue = false;
  dueColor: string = '';
  bgImageColor: string = '';
  bgContentColor: string = '';
  @Input() public dateFormatString: string = 'DD/MM/YYYY';
  @Input() public timeFormatString: string = 'hh:mm a';
  @Input() public cardDetails: KanbanViewCardI = {
    select: false,
    id: '',
    customerName: '',
    job: '',
    order: '',
    type: '',
    product: '',
    image: '',
    dueDate: '',
    machineId: '',
    machineName: '',
    scheduleDate: '',
    status: '',
    quantity: '',
    pinned: false,
    statusId: '',
    statusName: '',
    batchMaster: 0,
  };
  dueFontColor: string = '';
  
  constructor() { 
  }

  ngOnInit(): void {
    this.isOverdue = (this.cardDetails.dueDate !== null) && (moment() > moment(new Date(this.cardDetails.dueDate)));
    if(this.cardDetails.status && this.cardDetails.status === 'Done') {
      this.bgImageColor = '#e9f6dd'
    }
    if(this.cardDetails.quantity && this.cardDetails.quantity !== '0') {
      this.bgContentColor = '#e9f6dd'
    }
    
    if (this.cardDetails.dueDate && this.cardDetails.dueDate !== '0000-00-00') {
      let cardDate = moment(this.cardDetails.dueDate).endOf('day');
      let curDate = moment().endOf('day');
      let diff = cardDate.diff(curDate, 'hours');
      switch(true) {
        // red past due or due today
        case diff < 0:
          this.dueColor = 'red';
          this.dueFontColor = '#ffffff';
          break;
        //due today
        case diff == 0:
          this.dueColor = 'orange';
          this.dueFontColor = '#ffffff';
          break;
        // tomorrow
        case diff >= 24 && diff <= 24*2:
          this.dueColor = 'yellow';
          this.dueFontColor = '#000000';
          break;
        // this week
        case diff >= 24*2 && diff <= 24*7:
          this.dueColor = 'green';
          this.dueFontColor = '#ffffff';
          break;
        // next week
        case diff >= 24*7 && diff <= 24*14:
          this.dueColor = 'blue';
          this.dueFontColor = '#ffffff';
          break;
        // this month
        case diff >= 24*14 && diff <= 24*30:
          this.dueColor = 'black';
          this.dueFontColor = '#ffffff';
          break;
        default:
          this.dueColor = 'gray';
          this.dueFontColor = '#000000';
          break;              
      }
    }
  }

  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }
}
